if (!customElements.get('product-colours')) {
  customElements.define(
    'product-colours',
    class ProductColours extends window.BAO.CustomElement {
      constructor() {
        super()

        this.color = this.querySelectorAll('[data-colour]')
        this.titleEl = this.querySelector('[data-el="product-colours.title"]')
        this.colourEls = this.querySelectorAll('[data-el="product-colours.colour"]')

        // if (this.colourEls.length < 2) return

        this.initialiseColours()
      }

      initialiseColours() {
        if (!this.titleEl) return

        this.colourEls.forEach(colourEl => {
          colourEl.addEventListener('mouseenter', this.handleMouseEnter)
          colourEl.addEventListener('mouseleave', this.handleMouseLeave)
        })
      }

      handleMouseEnter = event => {
        this.titleEl.innerHTML = event.target.dataset.productColoursName
      }

      handleMouseLeave = () => {
        this.titleEl.innerHTML = this.dataset.productColoursDefault
      }
    },
  )
}